// icons
import { MdInventory2, MdInventory, MdHistory } from "react-icons/md";

const insumos = {
  id: 'insumos-group',
  type: 'group',
  roles: [1, 200],
  breadcrumbs: false,
  children: [
    {
      id: 'insumos',
      title: "Insumos",
      type: 'collapse',
      icon: MdInventory2,
      children: [
        {
          id: 'existencias',
          title: "Existencias",
          type: 'item',
          breadcrumbs: false,
          icon: MdInventory,
          url: '/insumos/existencias'
        },
        {
          id: 'bitacora-movimientos',
          title: "Bitácora de Movimientos",
          type: 'item',
          breadcrumbs: false,
          icon: MdHistory,
          url: '/insumos/bitacora-movimientos'
        }
      ]
    }
  ]
};

export default insumos;
